<div class="container-fluid campaign-background pt-0">
    <app-trial-license-warning></app-trial-license-warning>
    <lib-campaigns></lib-campaigns>
</div>  

<div class="content-section" [ngClass]="layoutService.expandedMenu ? 'expand' : ''">
    <div class="title-section title-bar title-bar-nav">
        <div class="title-div">
                <div class="col p-0 d-flex justify-content-between align-items-center changeInstitution">
                    <div class="col-11 p-0">
                        <a class="back_bd" (click)='backToManageInstitution()'>
                            <img class="svg mr-2" src="assets/ph-bhp-layout/svg/back.svg" />
                           {{ translationKeys.SOPObservation.Back | translate}}</a
                          >
                        <h2 class="background_title">{{institutionData && institutionData.groupInstitutions ? ('INSTITUTION_MANAGEMENT.VIEW_GROUP' | translate) : ('INSTITUTION_MANAGEMENT.VIEW_INSTITUTION'
                            | translate) }}</h2>
                    </div>
                </div>
        </div>
        <div class="container-nav">
            <nav class="nav nav-pills nav-title">
                <a class="nav-link" [routerLink]=institutionDetailTabs[0].url routerLinkActive='active'>{{ institutionDetailTabs[0].title | translate}}</a>
                <a class="nav-link" [routerLink]=institutionDetailTabs[1].url routerLinkActive='active'>{{ institutionDetailTabs[1].title | translate}}</a>
            </nav>
            <hr class="w-100 mb-4 nav-separator">

            <div class="d-block d-md-none">
                <div class="btn-group btn-block customDropdown" dropdown>
                    <button id="button-basic" dropdownToggle type="button" class="btn btn-muted btn-block dropdown-toggle" aria-controls="dropdown-basic">
              <!-- {{ButtonDropdown}} -->
            </button>
                    <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu btn-block customDropdownList" role="menu" aria-labelledby="button-basic">
                        <!-- <li role="menuitem"><a class="dropdown-item" href="#">Action</a></li> -->
                        <li role="menuitem active">
                            <a class="nav-link" routerLink=institutionDetailTabs[0].url routerLinkActive='active'>{{institutionDetailTabs[0].title | translate}}</a>
                        </li>
                        <li role="menuitem">
                            <a class="nav-link" routerLink=institutionDetailTabs[1].url routerLinkActive='active'>{{institutionDetailTabs[1].title | translate}}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="container-section-nav">
        <router-outlet></router-outlet>
    </div>
</div>
